import { action, observable, makeObservable } from "mobx";
import { injectable } from "../../other/injection";
import { ITheme, lightTheme, themeRegistry } from "./theme";

@injectable("singleton")
export class ThemeStore {
    @observable public theme: ITheme = lightTheme;

    constructor() {
        makeObservable(this);
    }

    @action
    public onThemeChange = (name: string) => {
        const theme = themeRegistry.find(x => x.name === name);
        if (theme) {
            this.theme = theme;
        } else {
            throw new Error("Theme not found");
        }
    };
}
